import { ref, reactive, computed, getCurrentInstance } from 'vue';
import { config } from '@/config';

export function useConfiguracionDeportistas(manager) {
    const { proxy: { $store, $toast } } = getCurrentInstance();

    const saving = ref(false);

    // Note: token is passed as query param because Dropzone legacy expects it this way.
    // This is a known exposure point — if Dropzone can be migrated to use headers instead,
    // this should be changed to avoid token appearing in server logs and browser history.
    const uploadUrl = computed(() =>
        `${config.API_BASE}/upload/image?permisos=public&api_key=${localStorage.getItem('token')}`
    );

    // Local editable copy — normalize 1/0 booleans for ToggleSwitch compatibility
    const managerLocal = reactive({ ...manager });
    managerLocal.activar_compra_por_invitacion_bases = !!managerLocal.activar_compra_por_invitacion_bases;
    managerLocal.documentacion_obligatoria_bases = !!managerLocal.documentacion_obligatoria_bases;
    managerLocal.indumentaria_plazos = !!managerLocal.indumentaria_plazos;

    function imagenBorrada() {
        managerLocal.imagen_info_bases = null;
        managerLocal.imagen_info_bases_url = null;
    }

    function imagenSubida(file, response) {
        managerLocal.imagen_info_bases = response;
    }

    async function guardar() {
        saving.value = true;
        try {
            const listaId = $store.getters.getListaId;
            await $store.dispatch(config.getVuexAlias('back.lista.editar.manager'), {
                lista_id: listaId,
                activar_compra_por_invitacion_bases: managerLocal.activar_compra_por_invitacion_bases,
                documentacion_obligatoria_bases: managerLocal.documentacion_obligatoria_bases,
                indumentaria_plazos: managerLocal.indumentaria_plazos,
                informacion_base: managerLocal.informacion_base,
                condiciones_bases_plazos: managerLocal.condiciones_bases_plazos,
                imagen_info_bases: managerLocal.imagen_info_bases
            });
            return true;
        } catch (error) {
            $toast.error(error.response?.data?.message || 'Error al guardar');
            return false;
        } finally {
            saving.value = false;
        }
    }

    return {
        managerLocal,
        saving,
        uploadUrl,
        imagenBorrada,
        imagenSubida,
        guardar
    };
}